<template>
    <loader v-if="loading" />
    <div v-else>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="{ ...chartOptions, title: { text: 'Samlet' }}" :series="totalSeries" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row v-for="team in teams" :key="team">
            <v-col>
                <v-card>
                    <v-card-text>
                        <vue-apex-charts height="400px" type="line" :options="{ ...chartOptions, title: { text: team }}" :series="teamSeries[team]" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
	components: {
		VueApexCharts
    },
    data () {
        return {
            loading: true,
            totalSeries: [],
            teamSeries: {},
            teams: [],
            chartOptions: {
                chart: {
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                grid: {
                    xaxis: {
                        lines: {
                            show: true
                        }
                    }
                },
                yaxis: [
                    {
                        labels: {
                            formatter: this.$options.filters.separator
                        },
                        seriesName: 'Total'
                    },
                    {
                        show: false,
                        labels: {
                            formatter: this.$options.filters.separator
                        },
                        seriesName: 'Total'
                    },
                    {
                        opposite: true,
                        labels: {
                            formatter: this.$options.filters.percentage
                        },
                        seriesName: 'Procentdel røde',
                        max: 1
                    }
                ],
                colors: ['#000000', '#F44336', '#FF00FF'],
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [0, 1, 2],
                    formatter: val => val > 0 && val < 1 ? this.$options.filters.percentage(val) : this.$options.filters.separator(val)
                }
            }
        }
    },
    computed: {
        year () {
            return this.$store.state.quality.year
        },
        department () {
            return this.$store.getters['quality/department']
        }
    },
    methods: {
        async getData () {
            this.loading = true
            const response = await this.$http().get('/quality/development/inboxes', {
                params: {
                    year: this.year,
                    department: this.department
                }
            })
            this.totalSeries = response.data.totalSeries
            this.teamSeries = response.data.teamSeries
            this.teams = response.data.teams
            this.loading = false
        }
    },
    watch: {
        year: function () {
            this.getData()
        }
    },
    created () {
        this.getData()
    }
}
</script>